import React, { useState, useEffect } from "react";
import Select from "react-select";
import MyVerticallyCenteredModal from "../imgUpload/modal";
import Button from "react-bootstrap/Button";
import {
  editElement,
  getAllImages,
  getAppParams,
  getElement,
  getAllPages,
  getPageDetail,
  republishElement,
  unpublishElement,
  publishElement,
  redraftElement,
  requestPublish,
} from "../../api/api";
import LabelImage from "./image";
import PageModal from "../modal/modal";
import ItemModal from "../modal/itemModal";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import GridList from "../list/gridList";
import { parseISOString } from "../../api/common";
import { NecStore } from "../../store/necStore";
import { UserLang, UserStore } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";

const HighlightTextGrid = (props) => {
  const [store, setStore] = useState([]);

  const dev = [
    {
      itemName: "web",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "android",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "iOS",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "appletv",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "androidtv",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "firetv",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "roku",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "tizen",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "webos",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "chromecast",
      itemSize: "",
      itemVisibility: null,
    },
  ];

  const [modalShow, setModalShow] = useState(false);
  const [allImage, setallImage] = useState([]);
  const [pageModalShow, setPageModalShow] = useState(false);
  const [itemModalShow, setitemModalShow] = useState(false);
  const [list, setList] = useState([]);
  const [device, setDevice] = useState(dev);
  // const [portrait,setPortrait] = useState(obj);
  // const [landscape,setLandscape] = useState(obj);
  // const [banner,setBanner] = useState(obj);
  const [allPage, setallPage] = useState([]);
  const role = NecStore.useState((s) => s.setting);
  const lan = UserLang.useState((s) => s.lan);
  const user = UserStore.useState((s) => s.user);
  const [allElem, setallElem] = useState([]);
  const [viewAll, setViewAll] = useState("");
  const page = {
    pageType: props.match.params.type,
    referenceName: "",
    urlName: "",
    displayName: "",
    displayNameVisibility: "",
    viewAllText: "",
    viewAllVisibility: "",
    viewAllPage: "",
    playlistId: "",
    portraitThumbnail: "",
    landscapeThumbnail: "",
    bannerImage: "",
    devices: device,
    items: list,
    draftStatus: true,
    publishStatus: false,
    republishStatus: false,
    autoPlay: false,
    autoPlayTimer: "500",
    tab1Name: "",
    tab2Name: "",
    tab3Name: "",
  };

  const [element, setElement] = useState(page);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getImage = async () => {
      try {
        const appl = await getAllImages(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));

        setallImage(opt);
      } catch (error) {}
    };
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const pageid = props.match.params.id;
      const result = await getElement(pageid).then(
        (result) => {
          setElement(result.data);
          getPageDet(result.data.items);
          setLoading(false);
        },
        (error) => {
          toastr.error("Unable to Load Data", "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const getPageDet = async (editing) => {
      const result = await getPageDetail(editing).then(
        (result) => {
          setallElem(result.data);
        },
        (error) => {}
      );
    };
    // const brandImage = async(editing)=>{
    // /* eslint-disable no-unused-vars */

    //         const temp_dev = editing.devices;
    //        /*  setElement({
    //           ...element,
    //           ["devices"]: temp_dev
    //         }); */
    //         setDevice([...temp_dev]);

    //         if(editing.portraitThumbnail !==null)
    //         {
    //           const result= await getImagesById(editing.portraitThumbnail).then((result)=>{
    //
    //             setPortrait(result.data);

    //           },(error)=>{
    //

    //           });
    //         }

    //       /* eslint-disable no-unused-vars */
    //       /* eslint-disable no-unused-vars */
    //       if(editing.landscapeThumbnail !==null)
    //       {
    //       const resulted= await getImagesById(editing.landscapeThumbnail).then((result)=>{
    //
    //         setLandscape(result.data);

    //       },(error)=>{
    //

    //       });
    //     }
    //     /* eslint-disable no-unused-vars */
    //        /* eslint-disable no-unused-vars */
    //        if(editing.bannerImage !==null)
    //        {
    //        const results= await getImagesById(editing.bannerImage).then((result)=>{
    //
    //         setBanner(result.data);

    //       },(error)=>{
    //

    //       });
    //     }
    //     /* eslint-disable no-unused-vars */
    //    if(editing.viewAllPage !==null)
    //    {
    //       /* eslint-disable no-unused-vars */
    //     const resul= await getPage(editing.viewAllPage).then((result)=>{
    //
    //       setViewAll(result.data.referenceName);

    //     },(error)=>{
    //

    //     });
    //  /* eslint-disable no-unused-vars */
    //    }
    // }
    const getPaged = async () => {
      try {
        const appl = await getAllPages(200, 0);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
          type: item.pageType,
        }));
        setallPage(opt);
      } catch (error) {}
    };
    /* eslint-disable no-unused-vars */
    getPaged();
    getImage();
    elementDetail();
    /* eslint-disable no-unused-vars */
  }, [
    props.match.params.id,
    store.draftStatus,
    store.publishStatus,
    store.republishStatus,
  ]);

  const setNotifications = async (editing) => {
    setLoading(true);
    /* eslint-disable no-unused-vars */
    const pageid = props.match.params.id;
    const result = await requestPublish(editing).then(
      (result) => {
        toastr.success("Request Sent", "Success");

        // brandImage(result.data);
        // setPage(result.data);
        setLoading(false);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const handlePublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: element.elementType,
      itemid: element._id,
      redirect: "element",
      message: "Content Editor requested to Publish " + element.displayName,
    };

    setNotifications(opt);
  };

  const handleUnpublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: element.elementType,
      itemid: element._id,
      redirect: "element",
      message: "Content Editor requested to Unpublish " + element.displayName,
    };

    setNotifications(opt);
  };

  const handleRepublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: element.elementType,
      itemid: element._id,
      redirect: "element",
      message: "Content Editor requested to Republish " + element.displayName,
    };

    setNotifications(opt);
  };

  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const onChangeItem = (value, evt) => {
    setElement({
      ...element,
      [evt.name]: value.id,
    });

    const temp_obj = {
      images: {
        application: "",
        createdBy: "",
        date: "",
        imageName: value.name,
        imagekey: value.key,
      },
    };
  };

  const onChangePage = (value, evt) => {
    setElement({
      ...element,
      [evt.name]: value.value,
    });
    setViewAll(value.label);
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setElement({
      ...element,
      [evt.target.name]: value,
    });
  };

  const draft = async (event) => {
    setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */

    const result = await editElement(element, pageid).then(
      (result) => {
        setStore(result.data);

        setLoading(false);
        toastr.success("Successfully Saved", "Success");
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const redraft = async (event) => {
    setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */

    const result = await redraftElement(element, pageid).then(
      (result) => {
        setStore(result.data);

        toastr.success("Successfully Saved", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      const pageid = props.match.params.id;

      /* eslint-disable no-unused-vars */
      const result = await publishElement(pageid).then(
        (result) => {
          setStore(result.data);

          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
    /* eslint-disable no-unused-vars */
  };

  const republish = async (event) => {
    // setDisable(true);
    setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;

    /* eslint-disable no-unused-vars */
    const result = await republishElement(pageid).then(
      (result) => {
        setStore(result.data);

        toastr.success("Successfully Published", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const unpublish = async (event) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;

    /* eslint-disable no-unused-vars */
    const result = await unpublishElement(pageid).then(
      (result) => {
        toastr.success("Successfully Unpublished", "Success");
        // setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        // setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const updateSize = (index, event) => {
    const newArray = device;
    newArray[index].itemSize = event.target.value;
    setDevice(newArray);
  };

  const updateautoPlay = (event) => {
    const newArray = element;
    newArray.autoPlay = event.target.checked;
    setElement(newArray);
  };
  const updateVisiblity = (index, event) => {
    const newArray = device;
    newArray[index].itemVisibility = event.target.checked;
    setDevice(newArray);
  };
  const handleListChange = (edit) => {
    const opt = edit.map((item) => ({
      itemid: item.value,
      itemRef: item.label,
      itemOrder: item.order,
      itemType: item.type,
    }));
    setList(opt);
    /*eslint-disable no-useless-computed-key */

    setElement({
      ...element,
      ["items"]: opt,
    });

    /*eslint-disable no-useless-computed-key */
  };
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Create Element
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={draft}>
                    <div className="row">
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Name used to identify this element on CMS"
                                }
                              />
                            )}
                            &nbsp;Reference Name&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Name used to identify this element on CMS"
                                }
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="referenceName"
                            className="form-control inside-form"
                            placeholder="Reference Name ..."
                            defaultValue={element.referenceName}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip info={"Title name for the element"} />
                            )}
                            &nbsp;Display Name&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Title name for the element"}
                                place={"right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="displayName"
                            className="form-control inside-form"
                            placeholder="Display Name ..."
                            defaultValue={element.displayName}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* <div className="col-sm-6">
      <div className="form-group">
        <label>Playlist ID</label>
        <input type="text" name="playlistId" className="form-control inside-form" placeholder="Playlist ..." defaultValue={element.playlistId} onChange={handleChange}   autoComplete="off" />
      </div>
    </div> */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip info={"Select to show display name"} />
                            )}
                            &nbsp;Display Name Visibility&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Select to show display name"}
                                place={"right"}
                              />
                            )}
                          </label>
                          <select
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="displayNameVisibility"
                            className="form-control inside-form"
                            value={element.displayNameVisibility}
                            onChange={handleChange}
                            required
                          >
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="Hide Always"
                            >
                              Hide Always
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="On Hover"
                            >
                              On Hover
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="Show Always"
                            >
                              Show Always
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="Show Header Only"
                            >
                              Show Header Only
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "This name should be Unique and Identical"
                                }
                              />
                            )}
                            &nbsp;URL Name&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "This name should be Unique and Identical"
                                }
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="urlName"
                            className="form-control inside-form"
                            placeholder="URL Name"
                            defaultValue={element.urlName}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip info={"Select to view all text name"} />
                            )}
                            &nbsp;View All Visibility&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Select to show display name"}
                                place={"right"}
                              />
                            )}
                          </label>
                          <select
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="viewAllVisibility"
                            className="form-control inside-form"
                            value={element.viewAllVisibility}
                            onChange={handleChange}
                            required
                          >
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="false"
                            >
                              Hide
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="true"
                            >
                              Show
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Text to show all the contents in the element"
                                }
                              />
                            )}
                            &nbsp;View All Text&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Text to show all the contents in the element"
                                }
                                place={"right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="viewAllText"
                            className="form-control inside-form"
                            placeholder="View All Text"
                            defaultValue={element.viewAllText}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="row">
                            {lan === "rtl" && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setPageModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  New
                                </Button>
                              </div>
                            )}
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Page to show when view all page is clicked"
                                    }
                                  />
                                )}
                                &nbsp;View All Page&nbsp;
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Page to show when view all page is clicked"
                                    }
                                  />
                                )}
                              </label>
                              <Select
                                name="viewAllPage"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allPage}
                                onChange={(value, event) =>
                                  onChangePage(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <span>{viewAll}</span>
                                </div>
                              </div>
                            </div>
                            {!(lan === "rtl") && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setPageModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  New
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Title for First section"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;First Section Name Header&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Title for First section"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="tab1Name"
                            className="form-control inside-form"
                            placeholder="First Section Name Header ..."
                            defaultValue={element.tab1Name}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Title for Second section"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Second Section Name Header&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Title for Second section"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="tab2Name"
                            className="form-control inside-form"
                            placeholder="Second Section Name Header ..."
                            defaultValue={element.tab2Name}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Title for Third section"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Third Section Name Header&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Title for Third section"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="tab3Name"
                            className="form-control inside-form"
                            placeholder="Third Section Name Header ..."
                            defaultValue={element.tab3Name}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={
                              "Select required elements available on the page"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Items Container&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={
                              "Select required elements available on the page"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>

                    <GridList
                      dir={lan === "rtl" ? "rtl" : "ltr"}
                      onShow={() => setitemModalShow(true)}
                      data={allPage}
                      url={props.match.params.id}
                      onChange={handleListChange}
                      listData={element.items}
                      {...props}
                      listType={"page"}
                      list={allElem}
                    ></GridList>
                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        Device Playlist Size
                      </label>
                    </div>
                    <div className="row mb-2 mt-2">
                      {element.devices.map((image, index) => (
                        <div className="col-sm-6" key={index}>
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              {image.itemName}
                            </label>
                            <input
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              type="number"
                              name={image.itemName + "size"}
                              className="form-control inside-form"
                              placeholder="Add Size"
                              defaultValue={image.itemSize}
                              onChange={(event) => updateSize(index, event)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="row mb-2 mt-2"></div>

                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={
                              "Manually enable visibility in different platforms"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Devices to Display&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={
                              "Manually enable visibility in different platforms"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>

                    <div className="row mb-2 mt-2">
                      {element.devices.map((image, index) => (
                        <div className="col-sm-6" key={index}>
                          <div className="form-group">
                            <div
                              className="custom-control custom-switch"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <input
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                                type="checkbox"
                                className="custom-control-input"
                                name={"customSwitch" + index}
                                id={"customSwitch" + index}
                                defaultChecked={image.itemVisibility}
                                onClick={(event) =>
                                  updateVisiblity(index, event)
                                }
                              />
                              <label
                                className="custom-control-label not-bold"
                                htmlFor={"customSwitch" + index}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {image.itemName}
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div
                      className="row mb-2 mt-2"
                      style={{
                        display:
                          props.match.params.type === "3dCarousel" ||
                          props.match.params.type === "multiCarousel" ||
                          props.match.params.type === "newsCarousel" ||
                          props.match.params.type === "movieCarousel"
                            ? "flex"
                            : "none",
                      }}
                    >
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            Autoplay
                          </label>

                          <div
                            className="custom-control custom-switch"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                          >
                            <input
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              type="checkbox"
                              className="custom-control-input"
                              name={"autoPlay"}
                              id={"autoPlay"}
                              defaultChecked={element.autoPlay}
                              onClick={(event) => updateautoPlay(event)}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "custom-control-label not-bold float-right"
                                  : "float-left custom-control-label not-bold"
                              }
                              htmlFor={"autoPlay"}
                            >
                              Autoplay
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            Autoplay Timer
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="number"
                            name="autoPlayTimer"
                            className="form-control inside-form"
                            placeholder="500"
                            defaultValue={element.autoPlayTimer}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        Information
                      </label>
                    </div>
                    <div className="row mb-2 mt-2"></div>

                    <div className="row mb-2 mt-2">
                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            Status:{" "}
                            <label
                              className={
                                element.publishStatus && element.draftStatus
                                  ? "badge badge-success"
                                  : "badge badge-danger"
                              }
                            >
                              {element.publishStatus && element.draftStatus
                                ? "Published"
                                : "Drafted"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            Created on: {parseISOString(element.createdDate)}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            Last Edit :{parseISOString(element.editedDate)}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            {element.publishStatus && element.draftStatus
                              ? "Published On :" +
                                parseISOString(element.editedDate)
                              : "Drafted on :" +
                                parseISOString(element.editedDate)}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          {/* <button type="submit" className="btn btn-primary" style={{width:"100px",marginRight:'6px'}}>Draft</button> */}

                          {element.draftStatus === true &&
                            element.publishStatus === false && (
                              <>
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                >
                                  Draft
                                </button>

                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handlePublishRequest}
                                    className="btn btn-success"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Publish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={publish}
                                    className="btn btn-success"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Publish
                                  </button>
                                )}
                              </>
                            )}
                          {element.draftStatus === true &&
                            element.publishStatus === true &&
                            element.republishStatus === false && (
                              <>
                                <button
                                  type="#!"
                                  onClick={redraft}
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                >
                                  Redraft
                                </button>
                                {/* <button type="#!" onClick={republish} className="btn btn-success" style={{width:"100px",marginRight:'6px'}}>Republish</button> */}
                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handleUnpublishRequest}
                                    className="btn btn-light"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Unpublish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={unpublish}
                                    className="btn btn-light"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Unpublish
                                  </button>
                                )}
                              </>
                            )}
                          {element.draftStatus === true &&
                            element.publishStatus === true &&
                            element.republishStatus === true && (
                              <>
                                <button
                                  type="#!"
                                  onClick={redraft}
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                >
                                  Redraft
                                </button>
                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handleRepublishRequest}
                                    className="btn btn-success"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Republish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={republish}
                                    className="btn btn-success"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Republish
                                  </button>
                                )}
                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handleUnpublishRequest}
                                    className="btn btn-light"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Unpublish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={unpublish}
                                    className="btn btn-light"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Unpublish
                                  </button>
                                )}
                              </>
                            )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          allimage={allImage}
        />

        <PageModal
          show={pageModalShow}
          onHide={() => setPageModalShow(false)}
          allimage={allImage}
        />
        <ItemModal
          show={itemModalShow}
          onHide={() => setitemModalShow(false)}
        />
      </section>
    );
  }
};

export default HighlightTextGrid;
